// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Configuration-module__root--OWxde {
    border: 1px solid rgb(61, 68, 77);
    padding: 10px;
    width: stretch;
}

.Configuration-module__slideForm--JaWp2 {
    padding: 10px 0;
    border-bottom: 1px solid rgb(61, 68, 77);
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.Configuration-module__inputs--N4Gte {
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.Configuration-module__checkbox--VgZ71 {
    margin-left: 0;
}

.Configuration-module__button-group--B0EcM {
    gap: 10px;
    display: inline-flex;
}
.Configuration-module__createBtn--VWJlz {
    display: flex;
    margin: auto;
    margin-top: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/modules/configuration/Configuration.module.css"],"names":[],"mappings":"AAAA;IACI,iCAAiC;IACjC,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,wCAAwC;IACxC,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,oBAAoB;AACxB;AACA;IACI,aAAa;IACb,YAAY;IACZ,gBAAgB;AACpB","sourcesContent":[".root {\n    border: 1px solid rgb(61, 68, 77);\n    padding: 10px;\n    width: stretch;\n}\n\n.slideForm {\n    padding: 10px 0;\n    border-bottom: 1px solid rgb(61, 68, 77);\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.inputs {\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n}\n\n.checkbox {\n    margin-left: 0;\n}\n\n.button-group {\n    gap: 10px;\n    display: inline-flex;\n}\n.createBtn {\n    display: flex;\n    margin: auto;\n    margin-top: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Configuration-module__root--OWxde`,
	"slideForm": `Configuration-module__slideForm--JaWp2`,
	"inputs": `Configuration-module__inputs--N4Gte`,
	"checkbox": `Configuration-module__checkbox--VgZ71`,
	"buttonGroup": `Configuration-module__button-group--B0EcM`,
	"createBtn": `Configuration-module__createBtn--VWJlz`
};
export default ___CSS_LOADER_EXPORT___;
